export default __webpack_public_path__ + "static/media/logo-with-legend@2x.9ac8f3c5.png";